import { GrowthDataSet } from '../../types/data-set.types';

// WHO Length/Height-for-age GIRLS
// Birth to 5 years (monthly measurements)
export const whoGirlsHeightMonthly: GrowthDataSet = {
  id: 'who-girls-height-monthly',
  source: 'WHO',
  title: 'Length/Height-for-age',
  intervalType: 'month',
  gender: 'female',
  measurementType: 'height',
  ageRange: { min: 0, max: 60 },
  displayUnit: 'cm',
  dataPoints: [
    {
      age: 0,
      m: 49.1477,
      s: 0.0379,
      sd: 1.8627,
      percentiles: {
        p1: 44.8,
        p3: 45.6,
        p5: 46.1,
        p15: 47.2,
        p25: 47.9,
        p50: 49.1,
        p75: 50.4,
        p85: 51.1,
        p95: 52.2,
        p97: 52.7,
        p99: 53.5,
      },
    },
    {
      age: 1,
      m: 53.6872,
      s: 0.0364,
      sd: 1.9542,
      percentiles: {
        p1: 49.1,
        p3: 50.0,
        p5: 50.5,
        p15: 51.7,
        p25: 52.4,
        p50: 53.7,
        p75: 55.0,
        p85: 55.7,
        p95: 56.9,
        p97: 57.4,
        p99: 58.2,
      },
    },
    {
      age: 2,
      m: 57.0673,
      s: 0.03568,
      sd: 2.0362,
      percentiles: {
        p1: 52.3,
        p3: 53.2,
        p5: 53.7,
        p15: 55.0,
        p25: 55.7,
        p50: 57.1,
        p75: 58.4,
        p85: 59.2,
        p95: 60.4,
        p97: 60.9,
        p99: 61.8,
      },
    },
    {
      age: 3,
      m: 59.8029,
      s: 0.0352,
      sd: 2.1051,
      percentiles: {
        p1: 54.9,
        p3: 55.8,
        p5: 56.3,
        p15: 57.6,
        p25: 58.4,
        p50: 59.8,
        p75: 61.2,
        p85: 62.0,
        p95: 63.3,
        p97: 63.8,
        p99: 64.7,
      },
    },
    {
      age: 4,
      m: 62.0899,
      s: 0.03486,
      sd: 2.1645,
      percentiles: {
        p1: 57.1,
        p3: 58.0,
        p5: 58.5,
        p15: 59.8,
        p25: 60.6,
        p50: 62.1,
        p75: 63.5,
        p85: 64.3,
        p95: 65.7,
        p97: 66.2,
        p99: 67.1,
      },
    },
    {
      age: 5,
      m: 64.0301,
      s: 0.03463,
      sd: 2.2174,
      percentiles: {
        p1: 58.9,
        p3: 59.9,
        p5: 60.4,
        p15: 61.7,
        p25: 62.5,
        p50: 64.0,
        p75: 65.5,
        p85: 66.3,
        p95: 67.7,
        p97: 68.2,
        p99: 69.2,
      },
    },
    {
      age: 6,
      m: 65.7311,
      s: 0.03448,
      sd: 2.2664,
      percentiles: {
        p1: 60.5,
        p3: 61.5,
        p5: 62.0,
        p15: 63.4,
        p25: 64.2,
        p50: 65.7,
        p75: 67.3,
        p85: 68.1,
        p95: 69.5,
        p97: 70.0,
        p99: 71.0,
      },
    },
    {
      age: 7,
      m: 67.2873,
      s: 0.03441,
      sd: 2.3154,
      percentiles: {
        p1: 61.9,
        p3: 62.9,
        p5: 63.5,
        p15: 64.9,
        p25: 65.7,
        p50: 67.3,
        p75: 68.8,
        p85: 69.7,
        p95: 71.1,
        p97: 71.6,
        p99: 72.7,
      },
    },
    {
      age: 8,
      m: 68.7498,
      s: 0.0344,
      sd: 2.365,
      percentiles: {
        p1: 63.2,
        p3: 64.3,
        p5: 64.9,
        p15: 66.3,
        p25: 67.2,
        p50: 68.7,
        p75: 70.3,
        p85: 71.2,
        p95: 72.6,
        p97: 73.2,
        p99: 74.3,
      },
    },
    {
      age: 9,
      m: 70.1435,
      s: 0.03444,
      sd: 2.4157,
      percentiles: {
        p1: 64.5,
        p3: 65.6,
        p5: 66.2,
        p15: 67.6,
        p25: 68.5,
        p50: 70.1,
        p75: 71.8,
        p85: 72.6,
        p95: 74.1,
        p97: 74.7,
        p99: 75.8,
      },
    },
    {
      age: 10,
      m: 71.4818,
      s: 0.03452,
      sd: 2.4676,
      percentiles: {
        p1: 65.7,
        p3: 66.8,
        p5: 67.4,
        p15: 68.9,
        p25: 69.8,
        p50: 71.5,
        p75: 73.1,
        p85: 74.0,
        p95: 75.5,
        p97: 76.1,
        p99: 77.2,
      },
    },
    {
      age: 11,
      m: 72.771,
      s: 0.03464,
      sd: 2.5208,
      percentiles: {
        p1: 66.9,
        p3: 68.0,
        p5: 68.6,
        p15: 70.2,
        p25: 71.1,
        p50: 72.8,
        p75: 74.5,
        p85: 75.4,
        p95: 76.9,
        p97: 77.5,
        p99: 78.6,
      },
    },
    {
      age: 12,
      m: 74.015,
      s: 0.03479,
      sd: 2.575,
      percentiles: {
        p1: 68.0,
        p3: 69.2,
        p5: 69.8,
        p15: 71.3,
        p25: 72.3,
        p50: 74.0,
        p75: 75.8,
        p85: 76.7,
        p95: 78.3,
        p97: 78.9,
        p99: 80.0,
      },
    },
    {
      age: 13,
      m: 75.2176,
      s: 0.03496,
      sd: 2.6296,
      percentiles: {
        p1: 69.1,
        p3: 70.3,
        p5: 70.9,
        p15: 72.5,
        p25: 73.4,
        p50: 75.2,
        p75: 77.0,
        p85: 77.9,
        p95: 79.5,
        p97: 80.2,
        p99: 81.3,
      },
    },
    {
      age: 14,
      m: 76.3817,
      s: 0.03514,
      sd: 2.6841,
      percentiles: {
        p1: 70.1,
        p3: 71.3,
        p5: 72.0,
        p15: 73.6,
        p25: 74.6,
        p50: 76.4,
        p75: 78.2,
        p85: 79.2,
        p95: 80.8,
        p97: 81.4,
        p99: 82.6,
      },
    },
    {
      age: 15,
      m: 77.5099,
      s: 0.03534,
      sd: 2.7392,
      percentiles: {
        p1: 71.1,
        p3: 72.4,
        p5: 73.0,
        p15: 74.7,
        p25: 75.7,
        p50: 77.5,
        p75: 79.4,
        p85: 80.3,
        p95: 82.0,
        p97: 82.7,
        p99: 83.9,
      },
    },
    {
      age: 16,
      m: 78.6055,
      s: 0.03555,
      sd: 2.7944,
      percentiles: {
        p1: 72.1,
        p3: 73.3,
        p5: 74.0,
        p15: 75.7,
        p25: 76.7,
        p50: 78.6,
        p75: 80.5,
        p85: 81.5,
        p95: 83.2,
        p97: 83.9,
        p99: 85.1,
      },
    },
    {
      age: 17,
      m: 79.671,
      s: 0.03576,
      sd: 2.849,
      percentiles: {
        p1: 73.0,
        p3: 74.3,
        p5: 75.0,
        p15: 76.7,
        p25: 77.7,
        p50: 79.7,
        p75: 81.6,
        p85: 82.6,
        p95: 84.4,
        p97: 85.0,
        p99: 86.3,
      },
    },
    {
      age: 18,
      m: 80.7079,
      s: 0.03598,
      sd: 2.9039,
      percentiles: {
        p1: 74.0,
        p3: 75.2,
        p5: 75.9,
        p15: 77.7,
        p25: 78.7,
        p50: 80.7,
        p75: 82.7,
        p85: 83.7,
        p95: 85.5,
        p97: 86.2,
        p99: 87.5,
      },
    },
    {
      age: 19,
      m: 81.7182,
      s: 0.0362,
      sd: 2.9582,
      percentiles: {
        p1: 74.8,
        p3: 76.2,
        p5: 76.9,
        p15: 78.7,
        p25: 79.7,
        p50: 81.7,
        p75: 83.7,
        p85: 84.8,
        p95: 86.6,
        p97: 87.3,
        p99: 88.6,
      },
    },
    {
      age: 20,
      m: 82.7036,
      s: 0.03643,
      sd: 3.0129,
      percentiles: {
        p1: 75.7,
        p3: 77.0,
        p5: 77.7,
        p15: 79.6,
        p25: 80.7,
        p50: 82.7,
        p75: 84.7,
        p85: 85.8,
        p95: 87.7,
        p97: 88.4,
        p99: 89.7,
      },
    },
    {
      age: 21,
      m: 83.6654,
      s: 0.03666,
      sd: 3.0672,
      percentiles: {
        p1: 76.5,
        p3: 77.9,
        p5: 78.6,
        p15: 80.5,
        p25: 81.6,
        p50: 83.7,
        p75: 85.7,
        p85: 86.8,
        p95: 88.7,
        p97: 89.4,
        p99: 90.8,
      },
    },
    {
      age: 22,
      m: 84.604,
      s: 0.03688,
      sd: 3.1202,
      percentiles: {
        p1: 77.3,
        p3: 78.7,
        p5: 79.5,
        p15: 81.4,
        p25: 82.5,
        p50: 84.6,
        p75: 86.7,
        p85: 87.8,
        p95: 89.7,
        p97: 90.5,
        p99: 91.9,
      },
    },
    {
      age: 23,
      m: 85.5202,
      s: 0.03711,
      sd: 3.1737,
      percentiles: {
        p1: 78.1,
        p3: 79.6,
        p5: 80.3,
        p15: 82.2,
        p25: 83.4,
        p50: 85.5,
        p75: 87.7,
        p85: 88.8,
        p95: 90.7,
        p97: 91.5,
        p99: 92.9,
      },
    },
    {
      age: 24,
      m: 86.4153,
      s: 0.03734,
      sd: 3.2267,
      percentiles: {
        p1: 78.9,
        p3: 80.3,
        p5: 81.1,
        p15: 83.1,
        p25: 84.2,
        p50: 86.4,
        p75: 88.6,
        p85: 89.8,
        p95: 91.7,
        p97: 92.5,
        p99: 93.9,
      },
    },
    // At 24 months, change from length to height measurement (child stands)
    {
      age: 25,
      m: 86.5904,
      s: 0.03786,
      sd: 3.2783,
      percentiles: {
        p1: 79.0,
        p3: 80.4,
        p5: 81.2,
        p15: 83.2,
        p25: 84.4,
        p50: 86.6,
        p75: 88.8,
        p85: 90.0,
        p95: 92.0,
        p97: 92.8,
        p99: 94.2,
      },
    },
    {
      age: 26,
      m: 87.4462,
      s: 0.03808,
      sd: 3.33,
      percentiles: {
        p1: 79.7,
        p3: 81.2,
        p5: 82.0,
        p15: 84.0,
        p25: 85.2,
        p50: 87.4,
        p75: 89.7,
        p85: 90.9,
        p95: 92.9,
        p97: 93.7,
        p99: 95.2,
      },
    },
    {
      age: 27,
      m: 88.283,
      s: 0.0383,
      sd: 3.3812,
      percentiles: {
        p1: 80.4,
        p3: 81.9,
        p5: 82.7,
        p15: 84.8,
        p25: 86.0,
        p50: 88.3,
        p75: 90.6,
        p85: 91.8,
        p95: 93.8,
        p97: 94.6,
        p99: 96.1,
      },
    },
    {
      age: 28,
      m: 89.1004,
      s: 0.03851,
      sd: 3.4313,
      percentiles: {
        p1: 81.1,
        p3: 82.6,
        p5: 83.5,
        p15: 85.5,
        p25: 86.8,
        p50: 89.1,
        p75: 91.4,
        p85: 92.7,
        p95: 94.7,
        p97: 95.6,
        p99: 97.1,
      },
    },
    {
      age: 29,
      m: 89.8991,
      s: 0.03872,
      sd: 3.4809,
      percentiles: {
        p1: 81.8,
        p3: 83.4,
        p5: 84.2,
        p15: 86.3,
        p25: 87.6,
        p50: 89.9,
        p75: 92.2,
        p85: 93.5,
        p95: 95.6,
        p97: 96.4,
        p99: 98.0,
      },
    },
    {
      age: 30,
      m: 90.6797,
      s: 0.03893,
      sd: 3.5302,
      percentiles: {
        p1: 82.5,
        p3: 84.0,
        p5: 84.9,
        p15: 87.0,
        p25: 88.3,
        p50: 90.7,
        p75: 93.1,
        p85: 94.3,
        p95: 96.5,
        p97: 97.3,
        p99: 98.9,
      },
    },
    // Continue with months 31-60...
    {
      age: 31,
      m: 91.443,
      s: 0.03913,
      sd: 3.5782,
      percentiles: {
        p1: 83.1,
        p3: 84.7,
        p5: 85.6,
        p15: 87.7,
        p25: 89.0,
        p50: 91.4,
        p75: 93.9,
        p85: 95.2,
        p95: 97.3,
        p97: 98.2,
        p99: 99.8,
      },
    },
    {
      age: 32,
      m: 92.1906,
      s: 0.03933,
      sd: 3.6259,
      percentiles: {
        p1: 83.8,
        p3: 85.4,
        p5: 86.2,
        p15: 88.4,
        p25: 89.7,
        p50: 92.2,
        p75: 94.6,
        p85: 95.9,
        p95: 98.2,
        p97: 99.0,
        p99: 100.6,
      },
    },
    {
      age: 33,
      m: 92.9239,
      s: 0.03952,
      sd: 3.6724,
      percentiles: {
        p1: 84.4,
        p3: 86.0,
        p5: 86.9,
        p15: 89.1,
        p25: 90.4,
        p50: 92.9,
        p75: 95.4,
        p85: 96.7,
        p95: 99.0,
        p97: 99.8,
        p99: 101.5,
      },
    },
    {
      age: 34,
      m: 93.6444,
      s: 0.03971,
      sd: 3.7186,
      percentiles: {
        p1: 85.0,
        p3: 86.7,
        p5: 87.5,
        p15: 89.8,
        p25: 91.1,
        p50: 93.6,
        p75: 96.2,
        p85: 97.5,
        p95: 99.8,
        p97: 100.6,
        p99: 102.3,
      },
    },
    {
      age: 35,
      m: 94.3533,
      s: 0.03989,
      sd: 3.7638,
      percentiles: {
        p1: 85.6,
        p3: 87.3,
        p5: 88.2,
        p15: 90.5,
        p25: 91.8,
        p50: 94.4,
        p75: 96.9,
        p85: 98.3,
        p95: 100.5,
        p97: 101.4,
        p99: 103.1,
      },
    },
    {
      age: 36,
      m: 95.0515,
      s: 0.04006,
      sd: 3.8078,
      percentiles: {
        p1: 86.2,
        p3: 87.9,
        p5: 88.8,
        p15: 91.1,
        p25: 92.5,
        p50: 95.1,
        p75: 97.6,
        p85: 99.0,
        p95: 101.3,
        p97: 102.2,
        p99: 103.9,
      },
    },
    {
      age: 37,
      m: 95.7399,
      s: 0.04024,
      sd: 3.8526,
      percentiles: {
        p1: 86.8,
        p3: 88.5,
        p5: 89.4,
        p15: 91.7,
        p25: 93.1,
        p50: 95.7,
        p75: 98.3,
        p85: 99.7,
        p95: 102.1,
        p97: 103.0,
        p99: 104.7,
      },
    },
    {
      age: 38,
      m: 96.4187,
      s: 0.04041,
      sd: 3.8963,
      percentiles: {
        p1: 87.4,
        p3: 89.1,
        p5: 90.0,
        p15: 92.4,
        p25: 93.8,
        p50: 96.4,
        p75: 99.0,
        p85: 100.5,
        p95: 102.8,
        p97: 103.7,
        p99: 105.5,
      },
    },
    {
      age: 39,
      m: 97.0885,
      s: 0.04057,
      sd: 3.9389,
      percentiles: {
        p1: 87.9,
        p3: 89.7,
        p5: 90.6,
        p15: 93.0,
        p25: 94.4,
        p50: 97.1,
        p75: 99.7,
        p85: 101.2,
        p95: 103.6,
        p97: 104.5,
        p99: 106.3,
      },
    },
    {
      age: 40,
      m: 97.7493,
      s: 0.04073,
      sd: 3.9813,
      percentiles: {
        p1: 88.5,
        p3: 90.3,
        p5: 91.2,
        p15: 93.6,
        p25: 95.1,
        p50: 97.7,
        p75: 100.4,
        p85: 101.9,
        p95: 104.3,
        p97: 105.2,
        p99: 107.0,
      },
    },
    {
      age: 41,
      m: 98.4015,
      s: 0.04089,
      sd: 4.0236,
      percentiles: {
        p1: 89.0,
        p3: 90.8,
        p5: 91.8,
        p15: 94.2,
        p25: 95.7,
        p50: 98.4,
        p75: 101.1,
        p85: 102.6,
        p95: 105.0,
        p97: 106.0,
        p99: 107.8,
      },
    },
    {
      age: 42,
      m: 99.0448,
      s: 0.04105,
      sd: 4.0658,
      percentiles: {
        p1: 89.6,
        p3: 91.4,
        p5: 92.4,
        p15: 94.8,
        p25: 96.3,
        p50: 99.0,
        p75: 101.8,
        p85: 103.3,
        p95: 105.7,
        p97: 106.7,
        p99: 108.5,
      },
    },
    {
      age: 43,
      m: 99.6795,
      s: 0.0412,
      sd: 4.1068,
      percentiles: {
        p1: 90.1,
        p3: 92.0,
        p5: 92.9,
        p15: 95.4,
        p25: 96.9,
        p50: 99.7,
        p75: 102.4,
        p85: 103.9,
        p95: 106.4,
        p97: 107.4,
        p99: 109.2,
      },
    },
    {
      age: 44,
      m: 100.3058,
      s: 0.04135,
      sd: 4.1476,
      percentiles: {
        p1: 90.7,
        p3: 92.5,
        p5: 93.5,
        p15: 96.0,
        p25: 97.5,
        p50: 100.3,
        p75: 103.1,
        p85: 104.6,
        p95: 107.1,
        p97: 108.1,
        p99: 110.0,
      },
    },
    {
      age: 45,
      m: 100.9238,
      s: 0.0415,
      sd: 4.1883,
      percentiles: {
        p1: 91.2,
        p3: 93.0,
        p5: 94.0,
        p15: 96.6,
        p25: 98.1,
        p50: 100.9,
        p75: 103.7,
        p85: 105.3,
        p95: 107.8,
        p97: 108.8,
        p99: 110.7,
      },
    },
    {
      age: 46,
      m: 101.5337,
      s: 0.04164,
      sd: 4.2279,
      percentiles: {
        p1: 91.7,
        p3: 93.6,
        p5: 94.6,
        p15: 97.2,
        p25: 98.7,
        p50: 101.5,
        p75: 104.4,
        p85: 105.9,
        p95: 108.5,
        p97: 109.5,
        p99: 111.4,
      },
    },
    {
      age: 47,
      m: 102.136,
      s: 0.04179,
      sd: 4.2683,
      percentiles: {
        p1: 92.2,
        p3: 94.1,
        p5: 95.1,
        p15: 97.7,
        p25: 99.3,
        p50: 102.1,
        p75: 105.0,
        p85: 106.6,
        p95: 109.2,
        p97: 110.2,
        p99: 112.1,
      },
    },
    {
      age: 48,
      m: 102.7312,
      s: 0.04193,
      sd: 4.3075,
      percentiles: {
        p1: 92.7,
        p3: 94.6,
        p5: 95.6,
        p15: 98.3,
        p25: 99.8,
        p50: 102.7,
        p75: 105.6,
        p85: 107.2,
        p95: 109.8,
        p97: 110.8,
        p99: 112.8,
      },
    },
    {
      age: 49,
      m: 103.3197,
      s: 0.04206,
      sd: 4.3456,
      percentiles: {
        p1: 93.2,
        p3: 95.1,
        p5: 96.2,
        p15: 98.8,
        p25: 100.4,
        p50: 103.3,
        p75: 106.3,
        p85: 107.8,
        p95: 110.5,
        p97: 111.5,
        p99: 113.4,
      },
    },
    {
      age: 50,
      m: 103.9021,
      s: 0.0422,
      sd: 4.3847,
      percentiles: {
        p1: 93.7,
        p3: 95.7,
        p5: 96.7,
        p15: 99.4,
        p25: 100.9,
        p50: 103.9,
        p75: 106.9,
        p85: 108.4,
        p95: 111.1,
        p97: 112.1,
        p99: 114.1,
      },
    },
    {
      age: 51,
      m: 104.4786,
      s: 0.04233,
      sd: 4.4226,
      percentiles: {
        p1: 94.2,
        p3: 96.2,
        p5: 97.2,
        p15: 99.9,
        p25: 101.5,
        p50: 104.5,
        p75: 107.5,
        p85: 109.1,
        p95: 111.8,
        p97: 112.8,
        p99: 114.8,
      },
    },
    {
      age: 52,
      m: 105.0494,
      s: 0.04246,
      sd: 4.4604,
      percentiles: {
        p1: 94.7,
        p3: 96.7,
        p5: 97.7,
        p15: 100.4,
        p25: 102.0,
        p50: 105.0,
        p75: 108.1,
        p85: 109.7,
        p95: 112.4,
        p97: 113.4,
        p99: 115.4,
      },
    },
    {
      age: 53,
      m: 105.6148,
      s: 0.04259,
      sd: 4.4981,
      percentiles: {
        p1: 95.2,
        p3: 97.2,
        p5: 98.2,
        p15: 101.0,
        p25: 102.6,
        p50: 105.6,
        p75: 108.6,
        p85: 110.3,
        p95: 113.0,
        p97: 114.1,
        p99: 116.1,
      },
    },
    {
      age: 54,
      m: 106.1748,
      s: 0.04272,
      sd: 4.5358,
      percentiles: {
        p1: 95.6,
        p3: 97.6,
        p5: 98.7,
        p15: 101.5,
        p25: 103.1,
        p50: 106.2,
        p75: 109.2,
        p85: 110.9,
        p95: 113.6,
        p97: 114.7,
        p99: 116.7,
      },
    },
    {
      age: 55,
      m: 106.7295,
      s: 0.04285,
      sd: 4.5734,
      percentiles: {
        p1: 96.1,
        p3: 98.1,
        p5: 99.2,
        p15: 102.0,
        p25: 103.6,
        p50: 106.7,
        p75: 109.8,
        p85: 111.5,
        p95: 114.3,
        p97: 115.3,
        p99: 117.4,
      },
    },
    {
      age: 56,
      m: 107.2788,
      s: 0.04298,
      sd: 4.6108,
      percentiles: {
        p1: 96.6,
        p3: 98.6,
        p5: 99.7,
        p15: 102.5,
        p25: 104.2,
        p50: 107.3,
        p75: 110.4,
        p85: 112.1,
        p95: 114.9,
        p97: 116.0,
        p99: 118.0,
      },
    },
    {
      age: 57,
      m: 107.8227,
      s: 0.0431,
      sd: 4.6472,
      percentiles: {
        p1: 97.0,
        p3: 99.1,
        p5: 100.2,
        p15: 103.0,
        p25: 104.7,
        p50: 107.8,
        p75: 111.0,
        p85: 112.6,
        p95: 115.5,
        p97: 116.6,
        p99: 118.6,
      },
    },
    {
      age: 58,
      m: 108.3613,
      s: 0.04322,
      sd: 4.6834,
      percentiles: {
        p1: 97.5,
        p3: 99.6,
        p5: 100.7,
        p15: 103.5,
        p25: 105.2,
        p50: 108.4,
        p75: 111.5,
        p85: 113.2,
        p95: 116.1,
        p97: 117.2,
        p99: 119.3,
      },
    },
    {
      age: 59,
      m: 108.8948,
      s: 0.04334,
      sd: 4.7195,
      percentiles: {
        p1: 97.9,
        p3: 100.0,
        p5: 101.1,
        p15: 104.0,
        p25: 105.7,
        p50: 108.9,
        p75: 112.1,
        p85: 113.8,
        p95: 116.7,
        p97: 117.8,
        p99: 119.9,
      },
    },
    {
      age: 60,
      m: 109.4233,
      s: 0.04347,
      sd: 4.7566,
      percentiles: {
        p1: 98.4,
        p3: 100.5,
        p5: 101.6,
        p15: 104.5,
        p25: 106.2,
        p50: 109.4,
        p75: 112.6,
        p85: 114.4,
        p95: 117.2,
        p97: 118.4,
        p99: 120.5,
      },
    },
  ],
};
